angular.module('jv.bulkResumeDownload.controller', [])
.controller('jvBulkResumeDownloadController', ['$scope','$rootScope','$window','$jobviteUrls','jvCandidatesService','jvHireBroadcastSVC',
    function($scope, $rootScope, $window, $jobviteUrls, jvCandidatesService, jvHireBroadcastSVC) {
        $scope.downloadResume = function(){
            var params = angular.copy($scope.modals.bulkResumeDownload);
            var data = {
                isSingle: params.isSingle,
                appIds: params.data.appIds,
                useCandName: params.candName,
                type: 'ResumeDownload'
            };
            window.localStorage.setItem('fileDownloadParams', JSON.stringify(data));
            $scope.hideModals(true);
            
            var win = $window.open($jobviteUrls.jhire+'/htm/common/bulkDownloadFile.html', '_blank');
            win.blur();
        };
        
        jvHireBroadcastSVC.subscribe('showBulkResumeDownloadModalView', function() {
            var postData = {
                data: $scope.modals.bulkResumeDownload.data.appIds,
                action: 'downloadResume'
            };

            jvCandidatesService.validateCandidateDetails(postData, function(res) {
                if (res.status !== 200 || !res.data) {
                    $scope.flags.loading = false;
                    return;
                }

                if(res.data.validApplicationIds.length === 0) {
                    var actionValidation = {};
                    actionValidation.show = true;
                    actionValidation.title = i18n.APPLICANT_APPLICANTGRID_DOWNLOAD_RESUMES;
                    actionValidation.message = i18n.CANDIDATES_RESUME_DOWNLOAD_PERMISSION_MSG;
                    $rootScope.$emit('actionValidation', actionValidation);
                    return;
                }
                $scope.modals.bulkResumeDownload.validationResult = res.data;
                $scope.modals.bulkResumeDownload.data.appIds = $scope.modals.bulkResumeDownload.validationResult.validApplicationIds;
                $scope.modals.bulkResumeDownload.count = $scope.modals.bulkResumeDownload.validationResult.validApplicationIds.length;
                var message = {};
                message.text = i18n.CANDIDATES_DOWNLOAD_RESUME_MSG;
                message.appendFirst = true;
                $scope.modals.bulkResumeDownload.validationResult.message = message;
                $scope.modals.bulkResumeDownload.show = true;
            });
        });
}]);

